import React from 'react'
import { Card, CardHeader, CardContent, TextField, Typography } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

import MaskedInput from 'react-text-mask'

function TextMaskCustom(props) {
	const { inputRef, ...other } = props

	return (
		<MaskedInput
			{...other}
			ref={(ref) => {
				inputRef(ref ? ref.inputElement : null)
			}}
			mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
			placeholderChar={'\u2000'}
			showMask
		/>
	)
}

const useStyles = makeStyles((theme) => ({
	formWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between'
	},
	fieldWrapper: {
		marginBottom: '20px',
		'& .MuiTextField-root': {
			minWidth: '275px'
		}
	}
}))

const ContactForm = (props) => {
	const classes = useStyles()

	let { client, setClient } = props

	return (
		<Card style={{ marginTop: '24px', marginBottom: '24px' }}>
			<CardHeader title="Contact" />
			<CardContent>
				<Typography variant="body2" style={{ fontWeight: 800, marginBottom: '16px' }}>
					Primary
				</Typography>
				<div className={classes.formWrapper}>
					<div className={classes.fieldWrapper}>
						<TextField
							id="household-select"
							variant="filled"
							label="First Name"
							value={client.firstName}
							onChange={(e) =>
								setClient({
									...client,
									firstName: e.target.value
								})
							}
						/>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							id="household-select"
							variant="filled"
							label="Last Name"
							value={client.lastName}
							onChange={(e) =>
								setClient({
									...client,
									lastName: e.target.value
								})
							}
						/>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							id="household-select"
							variant="filled"
							label="Phone"
							value={client.phone}
							InputProps={{
								inputComponent: TextMaskCustom
							}}
							onChange={(e) =>
								setClient({
									...client,
									phone: e.target.value
								})
							}
						/>
					</div>
					<div className={classes.fieldWrapper} style={{ width: '100%' }}>
						<TextField
							id="household-select"
							variant="filled"
							label="Email"
							fullWidth
							style={{ minWidth: '100%' }}
							value={client.email}
							onChange={(e) =>
								setClient({
									...client,
									email: e.target.value
								})
							}
							InputProps={{
								type: 'email'
							}}
						/>
					</div>
				</div>
			</CardContent>
		</Card>
	)
}

export default ContactForm
